import { Component, ReactNode } from "react";
import './../screens/styles/ShareNoteModal.css';
import { NotesService } from "../services/notes.service";
import { WithTranslation, withTranslation } from "react-i18next";

interface Iprops extends WithTranslation {
    noteId: string;
    open: boolean;
    onClose: () => void;
}

interface Istate {
    selectedUserIds: string[];
}

class ShareNoteModal extends Component<Iprops, Istate> {
    state: Readonly<Istate> = {
        selectedUserIds: [],
    };
    sharedUserIds: string[] = [];

    async componentDidMount() {
        const { selectedUserIds } = this.state;
        console.log("props", this.props)
        console.log("NotesService.connectedUsers", NotesService.connectedUsers);
        this.sharedUserIds = await NotesService.getSharedUsersByNoteId(this.props.noteId);
        const newSelectedUserIds: string[] = [];
        this.sharedUserIds.forEach(userid => {
            if (selectedUserIds.findIndex(id => id === userid) < 0) { // Si le user est déjà partagé, on l'ajoute à la liste des sélections 
                newSelectedUserIds.push(userid);
                this.setState({
                    selectedUserIds: newSelectedUserIds,
                });
            }
        });
        console.log("sharedUserIds", this.sharedUserIds);
    }

    onValid = () => {
        const { noteId, onClose } = this.props;
        const { selectedUserIds } = this.state;
        console.log("noteId", noteId);
        console.log("selectedUserIds", selectedUserIds);
        NotesService.ShareTo(noteId, selectedUserIds);
        onClose();
    }
    onClose = () => {
        const { onClose } = this.props;
        const newselectedUserIds: string[] = this.sharedUserIds.map(s => s);
        this.setState({
            selectedUserIds: newselectedUserIds,
        });
        onClose();
    }

    /**
     * Change le statut de sélection de utilisateur passé en paramètre
     * @param userId L'utilisateur dont on veut changer la sélection
     */
    toggleUser(userId: string) {
        const { selectedUserIds } = this.state;
        if (selectedUserIds.some(id => id === userId)) {
            this.setState({
                selectedUserIds: selectedUserIds.filter(id => id !== userId),
            })
        } else {
            selectedUserIds.push(userId);
            this.setState({
                selectedUserIds: selectedUserIds,
            });
        }
    }

    render(): ReactNode {
        const { open } = this.props;
        const { selectedUserIds } = this.state;
        return (
            <div className="modal-background" style={{ display: open ? "flex" : "none" }} onClick={this.onClose}>
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <h3 className="modal-title">Partager votre note avec :</h3>

                    <div className="list-container">
                        {
                            NotesService.connectedUsers.length > 0 && NotesService.connectedUsers.map(user =>
                                <div className={"user-btn" + (selectedUserIds.some(id => id === user.id) ? " checked" : "")} onClick={() => this.toggleUser(user.id)}>
                                    {user.displayName}
                                </div>
                            )
                        }
                    </div>

                    <div className="buttons-container">
                        <button className="button" onClick={this.onValid}>{this.props.t("save")}</button>
                        <button className="button" onClick={this.onClose}>{this.props.t("close")}</button>
                    </div>

                </div>

            </div>
        );
    }
}

export default withTranslation()(ShareNoteModal);